/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DebugUserInfo
 */
export interface DebugUserInfo {
    /**
     * 
     * @type {string}
     * @memberof DebugUserInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DebugUserInfo
     */
    account: string;
}

export function DebugUserInfoFromJSON(json: any): DebugUserInfo {
    return DebugUserInfoFromJSONTyped(json, false);
}

export function DebugUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebugUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'account': json['account'],
    };
}

export function DebugUserInfoToJSON(value?: DebugUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'account': value.account,
    };
}


